const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const formatMoney = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  };

  // ============================================================
  // DEMO DATA
  // ============================================================
  const demoProducts = [
    { id: 1, title: 'Wireless Noise-Cancelling Headphones', category: 'Electronics', price: 249.99, oldPrice: 299.99, rating: 4.8, reviews: 124, badge: 'sale', image: 'https://picsum.photos/seed/ox1/600/600', images: ['https://picsum.photos/seed/ox1/600/600', 'https://picsum.photos/seed/ox1a/600/600', 'https://picsum.photos/seed/ox1b/600/600', 'https://picsum.photos/seed/ox1c/600/600'], colors: ['#1a1a1a', '#f5f5f5', '#3b82f6'], sizes: ['One Size'], stock: true },
    { id: 2, title: 'Smart Fitness Watch Pro', category: 'Wearables', price: 189.00, oldPrice: null, rating: 4.6, reviews: 89, badge: 'new', image: 'https://picsum.photos/seed/ox2/600/600', images: ['https://picsum.photos/seed/ox2/600/600', 'https://picsum.photos/seed/ox2a/600/600', 'https://picsum.photos/seed/ox2b/600/600', 'https://picsum.photos/seed/ox2c/600/600'], colors: ['#1a1a1a', '#e5e7eb', '#ef4444'], sizes: ['S','M','L'], stock: true },
    { id: 3, title: 'Premium Leather Backpack', category: 'Accessories', price: 159.50, oldPrice: 199.00, rating: 4.9, reviews: 215, badge: 'hot', image: 'https://picsum.photos/seed/ox3/600/600', images: ['https://picsum.photos/seed/ox3/600/600', 'https://picsum.photos/seed/ox3a/600/600', 'https://picsum.photos/seed/ox3b/600/600', 'https://picsum.photos/seed/ox3c/600/600'], colors: ['#5c4033', '#1a1a1a', '#a0522d'], sizes: [], stock: true },
    { id: 4, title: 'Minimalist Desk Lamp', category: 'Home', price: 89.99, oldPrice: null, rating: 4.4, reviews: 67, badge: null, image: 'https://picsum.photos/seed/ox4/600/600', images: ['https://picsum.photos/seed/ox4/600/600', 'https://picsum.photos/seed/ox4a/600/600', 'https://picsum.photos/seed/ox4b/600/600', 'https://picsum.photos/seed/ox4c/600/600'], colors: ['#ffffff','#1a1a1a'], sizes: [], stock: true },
    { id: 5, title: 'Mechanical Keyboard RGB', category: 'Electronics', price: 139.99, oldPrice: 169.99, rating: 4.7, reviews: 156, badge: 'sale', image: 'https://picsum.photos/seed/ox5/600/600', images: ['https://picsum.photos/seed/ox5/600/600', 'https://picsum.photos/seed/ox5a/600/600', 'https://picsum.photos/seed/ox5b/600/600', 'https://picsum.photos/seed/ox5c/600/600'], colors: ['#1a1a1a','#f5f5f5'], sizes: [], stock: true },
    { id: 6, title: 'Ceramic Pour-Over Set', category: 'Home', price: 54.00, oldPrice: null, rating: 4.5, reviews: 42, badge: 'new', image: 'https://picsum.photos/seed/ox6/600/600', images: ['https://picsum.photos/seed/ox6/600/600', 'https://picsum.photos/seed/ox6a/600/600', 'https://picsum.photos/seed/ox6b/600/600', 'https://picsum.photos/seed/ox6c/600/600'], colors: ['#f5f5f5','#e8dcc4'], sizes: [], stock: true },
    { id: 7, title: 'Running Performance Shoes', category: 'Sports', price: 129.00, oldPrice: 159.00, rating: 4.6, reviews: 98, badge: 'sale', image: 'https://picsum.photos/seed/ox7/600/600', images: ['https://picsum.photos/seed/ox7/600/600', 'https://picsum.photos/seed/ox7a/600/600', 'https://picsum.photos/seed/ox7b/600/600', 'https://picsum.photos/seed/ox7c/600/600'], colors: ['#ef4444','#3b82f6','#1a1a1a'], sizes: ['7','8','9','10','11'], stock: true },
    { id: 8, title: 'Portable Bluetooth Speaker', category: 'Electronics', price: 79.99, oldPrice: null, rating: 4.3, reviews: 73, badge: null, image: 'https://picsum.photos/seed/ox8/600/600', images: ['https://picsum.photos/seed/ox8/600/600', 'https://picsum.photos/seed/ox8a/600/600', 'https://picsum.photos/seed/ox8b/600/600', 'https://picsum.photos/seed/ox8c/600/600'], colors: ['#1a1a1a','#10b981','#f59e0b'], sizes: [], stock: false },
    { id: 9, title: 'Organic Cotton T-Shirt Pack', category: 'Fashion', price: 45.00, oldPrice: 60.00, rating: 4.2, reviews: 34, badge: 'sale', image: 'https://picsum.photos/seed/ox9/600/600', images: ['https://picsum.photos/seed/ox9/600/600', 'https://picsum.photos/seed/ox9a/600/600', 'https://picsum.photos/seed/ox9b/600/600', 'https://picsum.photos/seed/ox9c/600/600'], colors: ['#ffffff','#1a1a1a','#6b7280'], sizes: ['S','M','L','XL'], stock: true },
    { id: 10, title: 'Stainless Steel Water Bottle', category: 'Sports', price: 34.99, oldPrice: null, rating: 4.8, reviews: 201, badge: 'hot', image: 'https://picsum.photos/seed/ox10/600/600', images: ['https://picsum.photos/seed/ox10/600/600', 'https://picsum.photos/seed/ox10a/600/600', 'https://picsum.photos/seed/ox10b/600/600', 'https://picsum.photos/seed/ox10c/600/600'], colors: ['#c0c0c0','#1a1a1a','#3b82f6'], sizes: ['500ml','750ml'], stock: true },
    { id: 11, title: 'Wireless Charging Pad', category: 'Electronics', price: 39.99, oldPrice: 49.99, rating: 4.1, reviews: 56, badge: 'sale', image: 'https://picsum.photos/seed/ox11/600/600', images: ['https://picsum.photos/seed/ox11/600/600', 'https://picsum.photos/seed/ox11a/600/600', 'https://picsum.photos/seed/ox11b/600/600', 'https://picsum.photos/seed/ox11c/600/600'], colors: ['#1a1a1a','#f5f5f5'], sizes: [], stock: true },
    { id: 12, title: 'Yoga Mat Premium', category: 'Sports', price: 68.00, oldPrice: null, rating: 4.7, reviews: 112, badge: 'new', image: 'https://picsum.photos/seed/ox12/600/600', images: ['https://picsum.photos/seed/ox12/600/600', 'https://picsum.photos/seed/ox12a/600/600', 'https://picsum.photos/seed/ox12b/600/600', 'https://picsum.photos/seed/ox12c/600/600'], colors: ['#a855f7','#10b981','#f59e0b'], sizes: [], stock: true },
  ];

  let cart = JSON.parse(localStorage.getItem('ox_cart') || '[]');
  let wishlist = JSON.parse(localStorage.getItem('ox_wishlist') || '[]');
  let compare = JSON.parse(localStorage.getItem('ox_compare') || '[]');

  const saveCart = () => localStorage.setItem('ox_cart', JSON.stringify(cart));
  const saveWishlist = () => localStorage.setItem('ox_wishlist', JSON.stringify(wishlist));
  const saveCompare = () => localStorage.setItem('ox_compare', JSON.stringify(compare));

  const findProduct = (id) => demoProducts.find(p => p.id === Number(id));

  const getCartItem = (id, variant = 'Default') => cart.find(item => item.id === Number(id) && item.variant === variant);

  const renderAddToCartBtn = (id, variant = 'Default', extraClasses = '') => {
    return `<button class="btn-add-cart js-card-add ${extraClasses}" data-id="${id}" data-variant="${variant}" type="button" aria-label="Add to cart"><i class="bi bi-cart-plus me-1"></i> Add to Cart</button>`;
  };

  const renderQtyCounter = (id, qty, variant = 'Default') => {
    return `<div class="shop-qty-control" role="group" aria-label="Quantity controls">
      <button type="button" class="shop-qty-btn js-card-qty" data-id="${id}" data-variant="${variant}" data-delta="-1" aria-label="Decrease quantity"><i class="bi bi-dash"></i></button>
      <span class="shop-qty-value" aria-live="polite">${qty}</span>
      <button type="button" class="shop-qty-btn js-card-qty" data-id="${id}" data-variant="${variant}" data-delta="1" aria-label="Increase quantity"><i class="bi bi-plus"></i></button>
    </div>`;
  };

  const syncCartButtons = (targetId, targetVariant) => {
    const wraps = (targetId != null)
      ? Array.from(document.querySelectorAll('.js-cart-btn-wrap')).filter(w => Number(w.dataset.id) === targetId && (w.dataset.variant || 'Default') === (targetVariant || 'Default'))
      : Array.from(document.querySelectorAll('.js-cart-btn-wrap'));
    wraps.forEach(wrap => {
      const id = Number(wrap.dataset.id);
      const variant = wrap.dataset.variant || 'Default';
      const item = getCartItem(id, variant);
      const qty = item ? item.qty : 0;
      if (qty > 0) {
        wrap.innerHTML = renderQtyCounter(id, qty, variant);
      } else {
        const isList = wrap.dataset.mode === 'list';
        wrap.innerHTML = renderAddToCartBtn(id, variant, isList ? 'btn btn-ox btn-ox-primary btn-sm' : '');
      }
    });
  };

  const upgradeStaticCartButtons = () => {
    document.querySelectorAll('.js-add-to-cart').forEach(btn => {
      const id = btn.dataset.id;
      const variant = btn.dataset.variant || 'Default';
      if (!id) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'js-cart-btn-wrap';
      wrapper.dataset.id = id;
      wrapper.dataset.variant = variant;
      if (btn.classList.contains('btn-ox-primary')) {
        wrapper.dataset.mode = 'list';
      }
      btn.replaceWith(wrapper);
    });
    syncCartButtons();
  };

  const updateCartItem = (id, delta, variant = 'Default') => {
    const item = cart.find(i => i.id === Number(id) && i.variant === variant);
    if (!item) return;
    item.qty += delta;
    if (item.qty <= 0) {
      cart = cart.filter(i => !(i.id === Number(id) && i.variant === variant));
    }
    saveCart();
    updateMiniCart();
    syncCartButtons(Number(id), variant);
    if (document.querySelector('.js-cart-page')) renderCartPage();
  };

  // ============================================================
  // BUTTON ANIMATIONS
  // ============================================================
  const animateButton = (btn) => {
    if (!btn) return;
    btn.classList.add('is-clicked');
    const onEnd = () => btn.classList.remove('is-clicked');
    btn.addEventListener('animationend', onEnd, { once: true });
    setTimeout(onEnd, 600);
  };

  const createRipple = (e, btn) => {
    const rect = btn.getBoundingClientRect();
    const ripple = document.createElement('span');
    ripple.className = 'shop-ripple';
    const size = Math.max(rect.width, rect.height);
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
    ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
    btn.appendChild(ripple);
    setTimeout(() => ripple.remove(), 650);
  };

  document.addEventListener('click', (e) => {
    const shopBtn = e.target.closest('.action-btn, .cart-item-remove, .ec-header-btn, .shop-qty-btn, .qty-control button, .js-pd-qty-btn, .js-compare-toggle, .js-wishlist-toggle, .btn-ox-primary, .btn-ox-dark, .btn-add-cart');
    if (shopBtn) {
      animateButton(shopBtn);
      if (shopBtn.classList.contains('btn-ox-primary') || shopBtn.classList.contains('btn-add-cart') || shopBtn.classList.contains('btn-ox-dark')) {
        createRipple(e, shopBtn);
      }
    }
  });

  // ============================================================
  // MINI CART
  // ============================================================
  const updateMiniCart = () => {
    const count = cart.reduce((sum, item) => sum + item.qty, 0);
    const total = cart.reduce((sum, item) => sum + (item.price * item.qty), 0);

    document.querySelectorAll('.js-cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'grid' : 'none';
    });

    const body = document.querySelector('.js-mini-cart-body');
    if (!body) return;

    if (cart.length === 0) {
      body.innerHTML = `
        <div class="empty-state py-5">
          <div class="empty-icon" style="width:64px;height:64px;font-size:1.5rem;margin-bottom:16px;"><i class="bi bi-cart-x"></i></div>
          <div class="empty-title" style="font-size:1rem;">Your cart is empty</div>
          <p class="empty-desc" style="font-size:0.85rem;">Add some products and come back.</p>
          <a href="shop.html" class="btn btn-ox btn-ox-primary btn-sm">Continue Shopping</a>
        </div>`;
    } else {
      body.innerHTML = cart.map(item => `
        <div class="mini-cart-item" data-cart-id="${item.id}">
          <img src="${item.image}" alt="${item.title}" class="mini-cart-thumb" loading="lazy" />
          <div class="mini-cart-info">
            <div class="mini-cart-title">${item.title}</div>
            <div class="mini-cart-meta">${item.variant || 'Default'}</div>
            <div class="mini-cart-row">
              <span class="fw-bold">${formatMoney(item.price)}</span>
              <div class="qty-control" style="transform:scale(0.85);transform-origin:left center;">
                <button type="button" class="js-cart-qty" data-id="${item.id}" data-delta="-1" aria-label="Decrease quantity"><i class="bi bi-dash"></i></button>
                <input type="text" value="${item.qty}" readonly aria-label="Quantity" />
                <button type="button" class="js-cart-qty" data-id="${item.id}" data-delta="1" aria-label="Increase quantity"><i class="bi bi-plus"></i></button>
              </div>
              <button class="shop-action-btn shop-action-btn--remove js-cart-remove" type="button" data-id="${item.id}" aria-label="Remove item" style="background:none;border:none;color:rgba(220,53,69,0.6);cursor:pointer;"><i class="bi bi-trash3"></i></button>
            </div>
          </div>
        </div>
      `).join('');
    }

    const totalEl = document.querySelector('.js-mini-cart-total');
    if (totalEl) totalEl.textContent = formatMoney(total);
  };

  const openMiniCart = () => {
    document.querySelector('.js-mini-cart-overlay')?.classList.add('is-open');
    document.querySelector('.js-mini-cart-drawer')?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeMiniCart = () => {
    document.querySelector('.js-mini-cart-overlay')?.classList.remove('is-open');
    document.querySelector('.js-mini-cart-drawer')?.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-open-mini-cart')) { e.preventDefault(); openMiniCart(); }
    if (e.target.closest('.js-close-mini-cart')) { closeMiniCart(); }
    if (e.target.matches('.js-mini-cart-overlay')) { closeMiniCart(); }

    const removeBtn = e.target.closest('.js-cart-remove');
    if (removeBtn) {
      const id = Number(removeBtn.dataset.id);
      const itemEl = removeBtn.closest('.mini-cart-item, .cart-item, .cart-mobile-card');
      const doRemove = () => {
        cart = cart.filter(item => item.id !== id);
        saveCart(); updateMiniCart(); syncCartButtons();
        if (document.querySelector('.js-cart-page')) renderCartPage();
      };
      if (itemEl) {
        itemEl.classList.add('is-removing');
        setTimeout(doRemove, 350);
      } else {
        doRemove();
      }
    }

    const qtyBtn = e.target.closest('.js-cart-qty');
    if (qtyBtn) {
      const id = Number(qtyBtn.dataset.id);
      const delta = Number(qtyBtn.dataset.delta);
      const item = cart.find(i => i.id === id);
      if (item) {
        item.qty = Math.max(1, item.qty + delta);
        saveCart(); updateMiniCart();
        if (document.querySelector('.js-cart-page')) renderCartPage();
      }
    }
  });

  // ============================================================
  // ADD TO CART
  // ============================================================
  const addToCart = (product, qty = 1, variant = 'Default') => {
    const existing = cart.find(item => item.id === product.id && item.variant === variant);
    if (existing) {
      existing.qty += qty;
    } else {
      cart.push({ id: product.id, title: product.title, price: product.price, image: product.image, variant, qty });
    }
    saveCart(); updateMiniCart(); openMiniCart(); syncCartButtons();
  };

  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.js-card-add');
    if (addBtn) {
      const wrap = addBtn.closest('.js-cart-btn-wrap');
      const id = Number(addBtn.dataset.id);
      const variant = addBtn.dataset.variant || 'Default';
      const product = findProduct(id);
      if (product) addToCart(product, 1, variant);
      return;
    }

    const qtyBtn = e.target.closest('.js-card-qty');
    if (qtyBtn) {
      const id = Number(qtyBtn.dataset.id);
      const delta = Number(qtyBtn.dataset.delta);
      const variant = qtyBtn.dataset.variant || 'Default';
      updateCartItem(id, delta, variant);
      return;
    }

    const legacyAdd = e.target.closest('.js-add-to-cart');
    if (legacyAdd) {
      const id = Number(legacyAdd.dataset.id);
      const product = findProduct(id);
      if (product) addToCart(product, 1, 'Default');
      return;
    }
  });

  // ============================================================
  // WISHLIST
  // ============================================================
  const updateWishlistIcons = () => {
    document.querySelectorAll('.js-wishlist-toggle, .js-pd-wishlist').forEach(btn => {
      const id = Number(btn.dataset.id);
      const active = wishlist.includes(id);
      btn.classList.toggle('is-active', active);
      btn.classList.toggle('shop-action-btn--active', active);
      const icon = btn.querySelector('i');
      if (icon) icon.className = active ? 'bi bi-heart-fill' : 'bi bi-heart';
    });
    document.querySelectorAll('.js-wishlist-count').forEach(el => {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length > 0 ? 'grid' : 'none';
    });
  };

  const createCelebration = (element) => {
    const rect = element.getBoundingClientRect();
    const particles = document.createElement('div');
    particles.className = 'celebration-particles';
    particles.style.cssText = `position:fixed;left:${rect.left + rect.width/2}px;top:${rect.top + rect.height/2}px;pointer-events:none;z-index:9999;`;
    for (let i = 0; i < 6; i++) {
      const p = document.createElement('div');
      p.className = 'particle';
      particles.appendChild(p);
    }
    document.body.appendChild(particles);
    setTimeout(() => particles.remove(), 700);
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-wishlist-toggle');
    if (!btn) return;
    const id = Number(btn.dataset.id);
    const wasInWishlist = wishlist.includes(id);
    if (wasInWishlist) {
      wishlist = wishlist.filter(w => w !== id);
    } else {
      wishlist.push(id);
      createCelebration(btn);
      btn.classList.add('celebrate');
      setTimeout(() => btn.classList.remove('celebrate'), 400);
    }
    saveWishlist(); updateWishlistIcons();
    if (document.querySelector('.js-wishlist-page')) renderWishlistPage();
  });

  // ============================================================
  // COMPARE
  // ============================================================
  const updateCompareIcons = () => {
    document.querySelectorAll('.js-compare-toggle').forEach(btn => {
      const id = Number(btn.dataset.id);
      const active = compare.includes(id);
      btn.classList.toggle('is-active', active);
      btn.classList.toggle('shop-action-btn--active', active);
    });
    document.querySelectorAll('.js-compare-count').forEach(el => {
      el.textContent = compare.length;
      el.style.display = compare.length > 0 ? 'grid' : 'none';
    });
  };

  const cleanCompare = () => {
    const validIds = new Set(demoProducts.map(p => p.id));
    compare = [...new Set(compare.filter(c => validIds.has(c)))];
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-compare-toggle');
    if (!btn) return;
    const id = Number(btn.dataset.id);
    if (!id || !demoProducts.some(p => p.id === id)) return;
    const wasInCompare = compare.includes(id);

    if (wasInCompare) {
      compare = compare.filter(c => c !== id);
    } else if (compare.length < 4) {
      compare.push(id);
      createCelebration(btn);
      btn.classList.add('celebrate');
      setTimeout(() => btn.classList.remove('celebrate'), 400);
    } else {
      alert('You can compare up to 4 products maximum.');
      return;
    }
    saveCompare(); updateCompareIcons();
    if (document.querySelector('.js-compare-page')) renderComparePage();
  });

  // ============================================================
  // SHOP PAGE FILTERS & GRID
  // ============================================================
  let shopView = 'grid';
  let activeFilters = { categories: [], priceMax: 500, rating: 0, search: '' };

  const renderShopGrid = () => {
    const container = document.querySelector('.js-shop-grid');
    const countEl = document.querySelector('.js-shop-count');
    if (!container) return;

    let filtered = demoProducts.filter(p => {
      if (activeFilters.search && !p.title.toLowerCase().includes(activeFilters.search.toLowerCase())) return false;
      if (activeFilters.categories.length && !activeFilters.categories.includes(p.category)) return false;
      if (p.price > activeFilters.priceMax) return false;
      if (activeFilters.rating && p.rating < activeFilters.rating) return false;
      return true;
    });

    const start = 0, perPage = 12;
    countEl && (countEl.textContent = `Showing ${Math.min(filtered.length, perPage)} of ${filtered.length} products`);

    if (filtered.length === 0) {
      container.innerHTML = `
        <div class="col-12">
          <div class="empty-state">
            <div class="empty-icon"><i class="bi bi-search"></i></div>
            <h4 class="empty-title">No products found</h4>
            <p class="empty-desc">Try adjusting your filters or search keywords.</p>
            <button class="btn btn-ox btn-ox-primary js-clear-filters">Clear Filters</button>
          </div>
        </div>`;
      return;
    }

    if (shopView === 'grid') {
      container.className = 'row g-4 js-shop-grid';
      container.innerHTML = filtered.slice(0, perPage).map(p => `
        <div class="col-6 col-md-4 col-lg-3">
          ${renderProductCard(p)}
        </div>
      `).join('');
    } else {
      container.className = 'js-shop-grid';
      container.innerHTML = filtered.slice(0, perPage).map(p => `
        <div class="product-list-item mb-3">
          <a href="product.html?id=${p.id}" class="product-list-image-link"><img src="${p.image}" alt="${p.title}" class="product-list-image" loading="lazy" /></a>
          <div class="product-list-body">
            <div class="product-category">${p.category}</div>
            <h5 class="product-title"><a href="product.html?id=${p.id}" class="text-decoration-none" style="color:inherit">${p.title}</a></h5>
            <div class="product-rating"><div class="stars">${renderStars(p.rating)}</div><span class="reviews-count">(${p.reviews})</span></div>
            <div class="product-price-row"><span class="price">${formatMoney(p.price)}</span>${p.oldPrice ? `<span class="price-old">${formatMoney(p.oldPrice)}</span>` : ''}</div>
            <p class="text-muted-ox small mb-2">Premium quality product with fast shipping and 2-year warranty included.</p>
            <div class="product-list-actions">
              <div class="js-cart-btn-wrap" data-id="${p.id}" data-variant="Default" data-mode="list"></div>
              <button class="btn btn-ox btn-ox-outline shop-action-btn shop-action-btn--wishlist js-wishlist-toggle" data-id="${p.id}" type="button" aria-label="Toggle wishlist"><i class="bi bi-heart"></i></button>
              <button class="btn btn-ox btn-ox-outline shop-action-btn shop-action-btn--compare js-compare-toggle" data-id="${p.id}" type="button" aria-label="Toggle compare"><i class="bi bi-arrow-left-right"></i></button>
            </div>
          </div>
        </div>
      `).join('');
    }
    updateWishlistIcons(); updateCompareIcons(); syncCartButtons();
  };

  const renderProductCard = (p) => {
    const badgeHtml = p.badge ? `<span class="badge-pill badge-${p.badge}">${p.badge}</span>` : '';
    return `
      <div class="product-card h-100">
        <div class="product-image-wrap">
          <img src="${p.image}" alt="${p.title}" class="product-image-primary" loading="lazy" />
          <div class="product-badge">${badgeHtml}</div>
          <div class="product-card-actions">
            <button class="action-btn shop-action-btn shop-action-btn--wishlist js-wishlist-toggle" data-id="${p.id}" title="Wishlist" type="button" aria-label="Toggle wishlist"><i class="bi bi-heart"></i></button>
            <button class="action-btn shop-action-btn shop-action-btn--compare js-compare-toggle" data-id="${p.id}" title="Compare" type="button" aria-label="Toggle compare"><i class="bi bi-arrow-left-right"></i></button>
            <button class="action-btn shop-action-btn js-quick-view" data-id="${p.id}" title="Quick View" type="button" data-bs-toggle="modal" data-bs-target="#quickViewModal" aria-label="Quick view"><i class="bi bi-eye"></i></button>
          </div>
        </div>
        <div class="product-card-body">
          <div class="product-category">${p.category}</div>
          <a href="product.html?id=${p.id}" class="product-title">${p.title}</a>
          <div class="product-rating"><div class="stars">${renderStars(p.rating)}</div><span class="reviews-count">(${p.reviews})</span></div>
          <div class="product-price-row"><span class="price">${formatMoney(p.price)}</span>${p.oldPrice ? `<span class="price-old">${formatMoney(p.oldPrice)}</span>` : ''}</div>
          <div class="js-cart-btn-wrap" data-id="${p.id}" data-variant="Default"></div>
        </div>
      </div>
    `;
  };

  const renderStars = (rating) => {
    let html = '';
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) html += '<i class="bi bi-star-fill"></i>';
      else if (i - 0.5 <= rating) html += '<i class="bi bi-star-half"></i>';
      else html += '<i class="bi bi-star"></i>';
    }
    return html;
  };

  document.addEventListener('click', (e) => {
    const viewBtn = e.target.closest('.js-view-toggle');
    if (viewBtn) {
      shopView = viewBtn.dataset.view;
      document.querySelectorAll('.js-view-toggle').forEach(b => b.classList.toggle('is-active', b.dataset.view === shopView));
      renderShopGrid();
    }

    const search = e.target.closest('.js-shop-search');
    if (search) {
      search.addEventListener('input', () => { activeFilters.search = search.value; renderShopGrid(); });
    }

    const sort = e.target.closest('.js-shop-sort');
    if (sort) {
      sort.addEventListener('change', () => {
        const val = sort.value;
        if (val === 'price-asc') demoProducts.sort((a,b) => a.price - b.price);
        else if (val === 'price-desc') demoProducts.sort((a,b) => b.price - a.price);
        else if (val === 'rating') demoProducts.sort((a,b) => b.rating - a.rating);
        else demoProducts.sort((a,b) => a.id - b.id);
        renderShopGrid();
      });
    }

    const chip = e.target.closest('.js-filter-chip');
    if (chip) {
      const cat = chip.dataset.category;
      chip.classList.toggle('is-active');
      if (activeFilters.categories.includes(cat)) activeFilters.categories = activeFilters.categories.filter(c => c !== cat);
      else activeFilters.categories.push(cat);
      renderShopGrid(); updateActiveFilterBar();
    }

    const clearBtn = e.target.closest('.js-clear-filters');
    if (clearBtn) {
      activeFilters = { categories: [], priceMax: 500, rating: 0, search: '' };
      document.querySelectorAll('.js-filter-chip').forEach(c => c.classList.remove('is-active'));
      const searchInput = document.querySelector('.js-shop-search');
      if (searchInput) searchInput.value = '';
      renderShopGrid(); updateActiveFilterBar();
    }

    const removeTag = e.target.closest('.js-remove-filter');
    if (removeTag) {
      const cat = removeTag.dataset.category;
      activeFilters.categories = activeFilters.categories.filter(c => c !== cat);
      document.querySelectorAll('.js-filter-chip').forEach(c => { if(c.dataset.category === cat) c.classList.remove('is-active'); });
      renderShopGrid(); updateActiveFilterBar();
    }

    const filterHeader = e.target.closest('.js-filter-header');
    if (filterHeader) {
      const body = filterHeader.nextElementSibling;
      filterHeader.classList.toggle('is-open');
      body && body.classList.toggle('is-open');
    }

    const rangeInput = e.target.closest('.js-price-range');
    if (rangeInput) {
      rangeInput.addEventListener('input', () => {
        activeFilters.priceMax = Number(rangeInput.value);
        document.querySelector('.js-price-max') && (document.querySelector('.js-price-max').textContent = formatMoney(activeFilters.priceMax));
        renderShopGrid();
      });
    }
  });

  const updateActiveFilterBar = () => {
    const bar = document.querySelector('.js-active-filters');
    if (!bar) return;
    const tags = activeFilters.categories.map(cat => `<span class="active-filter-tag js-remove-filter" data-category="${cat}">${cat} <i class="bi bi-x-lg"></i></span>`).join('');
    bar.innerHTML = tags + (activeFilters.categories.length ? '<button class="clear-filters js-clear-filters">Clear all</button>' : '');
  };

  // ============================================================
  // QUICK VIEW
  // ============================================================
  document.addEventListener('show.bs.modal', (e) => {
    if (e.target.id !== 'quickViewModal') return;
    const btn = document.querySelector('.js-quick-view[data-bs-target="#quickViewModal"]');
    const trigger = e.relatedTarget || btn;
    if (!trigger) return;
    const id = Number(trigger.dataset.id);
    const p = findProduct(id);
    if (!p) return;
    const modal = e.target;
    modal.querySelector('.js-qv-image').src = p.image;
    modal.querySelector('.js-qv-title').textContent = p.title;
    modal.querySelector('.js-qv-price').textContent = formatMoney(p.price);
    modal.querySelector('.js-qv-rating').innerHTML = renderStars(p.rating);
    modal.querySelector('.js-qv-reviews').textContent = `(${p.reviews} reviews)`;
    modal.querySelector('.js-qv-desc').textContent = 'Premium quality product with fast shipping and 2-year warranty included.';
    const addBtn = modal.querySelector('.js-qv-add');
    if (addBtn) { addBtn.dataset.id = p.id; }
    const linkBtn = modal.querySelector('.js-qv-link');
    if (linkBtn) linkBtn.href = `product.html?id=${p.id}`;
  });

  document.addEventListener('click', (e) => {
    const qvAdd = e.target.closest('.js-qv-add');
    if (qvAdd) {
      const id = Number(qvAdd.dataset.id);
      const product = findProduct(id);
      if (product) addToCart(product);
    }
  });

  // ============================================================
  // PRODUCT DETAILS PAGE
  // ============================================================
  const initProductPage = () => {
    const page = document.querySelector('.js-product-page');
    if (!page) return;
    const params = new URLSearchParams(location.search);
    const id = Number(params.get('id'));
    const p = findProduct(id) || demoProducts[0];

    const mainImg = page.querySelector('.js-pd-main-img');
    if (mainImg) mainImg.src = p.image;

    page.querySelectorAll('.js-pd-title').forEach(el => el.textContent = p.title);
    page.querySelectorAll('.js-pd-category').forEach(el => el.textContent = p.category);
    page.querySelectorAll('.js-pd-price').forEach(el => el.textContent = formatMoney(p.price));
    page.querySelectorAll('.js-pd-old-price').forEach(el => el.textContent = p.oldPrice ? formatMoney(p.oldPrice) : '');
    page.querySelectorAll('.js-pd-old-price').forEach(el => el.style.display = p.oldPrice ? '' : 'none');
    page.querySelectorAll('.discount-badge').forEach(el => el.style.display = p.oldPrice ? '' : 'none');
    page.querySelectorAll('.js-pd-rating').forEach(el => el.innerHTML = renderStars(p.rating));
    page.querySelectorAll('.js-pd-reviews').forEach(el => el.textContent = `(${p.reviews} reviews)`);
    page.querySelectorAll('.js-pd-stock').forEach(el => {
      el.innerHTML = p.stock ? '<i class="bi bi-check-circle-fill"></i> In Stock' : '<i class="bi bi-x-circle-fill"></i> Out of Stock';
      el.classList.toggle('out-of-stock', !p.stock);
    });

    const thumbs = page.querySelector('.js-pd-thumbs');
    const images = p.images || [p.image, p.image, p.image, p.image];
    let currentImageIndex = 0;

    const updateMainImage = (index) => {
      currentImageIndex = index;
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = images[index];
          mainImg.style.opacity = '1';
        }, 150);
      }
      if (thumbs) {
        thumbs.querySelectorAll('.thumb').forEach((x, i) => x.classList.toggle('is-active', i === index));
      }
    };

    if (thumbs) {
      thumbs.innerHTML = images.map((src, i) => `
        <div class="thumb ${i===0?'is-active':''}" data-index="${i}"><img src="${src}" alt="" loading="lazy" /></div>
      `).join('');
      thumbs.addEventListener('click', (e) => {
        const t = e.target.closest('.thumb');
        if (!t) return;
        const index = Number(t.dataset.index);
        updateMainImage(index);
      });
    }

    const prevBtn = page.querySelector('.js-gallery-prev');
    const nextBtn = page.querySelector('.js-gallery-next');
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const newIndex = (currentImageIndex - 1 + images.length) % images.length;
        updateMainImage(newIndex);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const newIndex = (currentImageIndex + 1) % images.length;
        updateMainImage(newIndex);
      });
    }

    if (mainImg) mainImg.style.transition = 'opacity 150ms ease';

    const colorWrap = page.querySelector('.js-pd-colors');
    if (colorWrap && p.colors.length) {
      colorWrap.innerHTML = p.colors.map((c, i) => `<span class="variant-color ${i===0?'is-active':''}" style="background:${c};" data-color="${c}"></span>`).join('');
      colorWrap.addEventListener('click', (e) => {
        const c = e.target.closest('.variant-color');
        if (!c) return;
        colorWrap.querySelectorAll('.variant-color').forEach(x => x.classList.remove('is-active'));
        c.classList.add('is-active');
      });
    }

    const sizeWrap = page.querySelector('.js-pd-sizes');
    if (sizeWrap && p.sizes.length) {
      sizeWrap.innerHTML = p.sizes.map((s, i) => `<button class="variant-btn ${i===0?'is-active':''}">${s}</button>`).join('');
      sizeWrap.addEventListener('click', (e) => {
        const b = e.target.closest('.variant-btn');
        if (!b) return;
        sizeWrap.querySelectorAll('.variant-btn').forEach(x => x.classList.remove('is-active'));
        b.classList.add('is-active');
      });
    }

    const qtyInput = page.querySelector('.js-pd-qty');
    page.querySelectorAll('.js-pd-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const delta = Number(btn.dataset.delta);
        qtyInput.value = Math.max(1, Number(qtyInput.value) + delta);
      });
    });

    const addBtn = page.querySelector('.js-pd-add');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        addToCart(p, Number(qtyInput?.value || 1));
      });
    }

    const wishBtn = page.querySelector('.js-pd-wishlist');
    if (wishBtn) {
      wishBtn.dataset.id = p.id;
      wishBtn.addEventListener('click', () => {
        if (wishlist.includes(p.id)) wishlist = wishlist.filter(w => w !== p.id);
        else wishlist.push(p.id);
        saveWishlist(); updateWishlistIcons();
        wishBtn.classList.toggle('is-active', wishlist.includes(p.id));
      });
      wishBtn.classList.toggle('is-active', wishlist.includes(p.id));
    }

    const relatedWrap = page.querySelector('.js-related-products');
    if (relatedWrap) {
      const related = demoProducts.filter(x => x.category === p.category && x.id !== p.id).slice(0, 4);
      if (related.length === 0) {
        relatedWrap.closest('section').style.display = 'none';
      } else {
        relatedWrap.innerHTML = related.map(r => `
          <div class="col-6 col-md-3">${renderProductCard(r)}</div>
        `).join('');
        updateWishlistIcons(); updateCompareIcons();
      }
    }
  };

  // ============================================================
  // CART PAGE
  // ============================================================
  const renderCartPage = () => {
    const page = document.querySelector('.js-cart-page');
    if (!page) return;
    const desktopBody = page.querySelector('.js-cart-desktop');
    const mobileBody = page.querySelector('.js-cart-mobile');
    const emptyState = page.querySelector('.js-cart-empty');
    const recommended = page.querySelector('.js-cart-recommended');
    const summaryCard = page.querySelector('.js-cart-summary');
    const cartContent = page.querySelector('.js-cart-content');
    const summarySub = page.querySelector('.js-summary-subtotal');
    const summaryTotal = page.querySelector('.js-summary-total');

    if (cart.length === 0) {
      if (desktopBody) { desktopBody.style.display = 'none'; desktopBody.innerHTML = ''; }
      if (mobileBody) { mobileBody.style.display = 'none'; mobileBody.innerHTML = ''; }
      emptyState && (emptyState.style.display = 'block');
      if (recommended) recommended.style.display = 'none';
      if (summaryCard) summaryCard.style.display = 'none';
      if (cartContent) cartContent.style.display = 'none';
      if (summarySub) summarySub.textContent = formatMoney(0);
      if (summaryTotal) summaryTotal.textContent = formatMoney(0);
      return;
    }

    if (cartContent) cartContent.style.display = 'block';
    desktopBody && (desktopBody.style.display = 'block');
    mobileBody && (mobileBody.style.display = 'block');
    emptyState && (emptyState.style.display = 'none');
    if (recommended) recommended.style.display = 'block';
    if (summaryCard) summaryCard.style.display = 'block';

    const subtotal = cart.reduce((s, item) => s + item.price * item.qty, 0);
    if (summarySub) summarySub.textContent = formatMoney(subtotal);
    if (summaryTotal) summaryTotal.textContent = formatMoney(subtotal + 12);

    if (desktopBody) {
      desktopBody.innerHTML = cart.map(item => `
        <div class="cart-item">
          <img src="${item.image}" alt="${item.title}" class="cart-item-thumb" loading="lazy" />
          <div class="cart-item-info">
            <div class="cart-item-title">${item.title}</div>
            <div class="cart-item-variant">${item.variant}</div>
          </div>
          <div class="cart-item-price">${formatMoney(item.price)}</div>
          <div class="qty-control">
            <button type="button" class="js-cart-qty" data-id="${item.id}" data-delta="-1" aria-label="Decrease quantity"><i class="bi bi-dash"></i></button>
            <input type="text" value="${item.qty}" readonly aria-label="Quantity" />
            <button type="button" class="js-cart-qty" data-id="${item.id}" data-delta="1" aria-label="Increase quantity"><i class="bi bi-plus"></i></button>
          </div>
          <div class="cart-item-subtotal">${formatMoney(item.price * item.qty)}</div>
          <button class="cart-item-remove shop-action-btn shop-action-btn--remove js-cart-remove" type="button" data-id="${item.id}" aria-label="Remove item"><i class="bi bi-trash3"></i></button>
        </div>
      `).join('');
    }

    if (mobileBody) {
      mobileBody.innerHTML = cart.map(item => `
        <div class="cart-mobile-card">
          <div class="cart-mobile-header">
            <img src="${item.image}" alt="${item.title}" loading="lazy" />
            <div>
              <div class="fw-bold">${item.title}</div>
              <div class="text-muted-ox small">${item.variant}</div>
            </div>
          </div>
          <div class="cart-mobile-row">
            <div class="qty-control" style="transform:scale(0.9);transform-origin:left center;">
              <button type="button" class="js-cart-qty" data-id="${item.id}" data-delta="-1" aria-label="Decrease quantity"><i class="bi bi-dash"></i></button>
              <input type="text" value="${item.qty}" readonly aria-label="Quantity" />
              <button type="button" class="js-cart-qty" data-id="${item.id}" data-delta="1" aria-label="Increase quantity"><i class="bi bi-plus"></i></button>
            </div>
            <div class="fw-bold">${formatMoney(item.price * item.qty)}</div>
            <button class="shop-action-btn shop-action-btn--remove js-cart-remove" type="button" data-id="${item.id}" aria-label="Remove item" style="background:none;border:none;color:rgba(220,53,69,0.6);"><i class="bi bi-trash3"></i></button>
          </div>
        </div>
      `).join('');
    }
  };

  // ============================================================
  // WISHLIST PAGE
  // ============================================================
  const renderWishlistPage = () => {
    const wrap = document.querySelector('.js-wishlist-grid');
    const empty = document.querySelector('.js-wishlist-empty');
    if (!wrap) return;
    const items = demoProducts.filter(p => wishlist.includes(p.id));
    if (items.length === 0) {
      wrap.style.display = 'none';
      empty && (empty.style.display = 'block');
      return;
    }
    wrap.style.display = 'flex';
    empty && (empty.style.display = 'none');
    wrap.innerHTML = items.map(p => `
      <div class="col-6 col-md-4 col-lg-3">${renderProductCard(p)}</div>
    `).join('');
    updateWishlistIcons(); updateCompareIcons(); syncCartButtons();
  };

  // ============================================================
  // COMPARE PAGE
  // ============================================================
  const renderComparePage = () => {
    const wrap = document.querySelector('.js-compare-table');
    const empty = document.querySelector('.js-compare-empty');
    if (!wrap) return;
    const items = demoProducts.filter(p => compare.includes(p.id));
    if (items.length === 0) {
      wrap.style.display = 'none';
      empty && (empty.style.display = 'block');
      return;
    }
    wrap.style.display = 'block';
    empty && (empty.style.display = 'none');

    const rows = [
      { label: 'Product', render: (p) => `<div class="compare-product"><img src="${p.image}" alt="${p.title}"/><div class="compare-title">${p.title}</div><button class="btn btn-ox btn-ox-primary btn-sm js-add-to-cart" data-id="${p.id}">Add to Cart</button><button class="btn btn-sm btn-link text-danger js-compare-remove" data-id="${p.id}" style="font-size:0.8rem;">Remove</button></div>` },
      { label: 'Price', render: (p) => `<span class="fw-bold">${formatMoney(p.price)}</span>` },
      { label: 'Rating', render: (p) => `<div class="stars">${renderStars(p.rating)}</div>` },
      { label: 'Availability', render: (p) => p.stock ? '<span class="text-success fw-bold">In Stock</span>' : '<span class="text-danger fw-bold">Out of Stock</span>' },
      { label: 'Category', render: (p) => p.category },
      { label: 'Reviews', render: (p) => `${p.reviews}` },
    ];

    let html = '<table>';
    rows.forEach(row => {
      html += `<tr><th>${row.label}</th>`;
      items.forEach(p => html += `<td>${row.render(p)}</td>`);
      html += '</tr>';
    });
    html += '</table>';
    wrap.innerHTML = html;

    wrap.querySelectorAll('.js-compare-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        compare = compare.filter(c => c !== Number(btn.dataset.id));
        saveCompare(); renderComparePage();
      });
    });
    upgradeStaticCartButtons();
  };

  // ============================================================
  // CHECKOUT PAGE
  // ============================================================
  const initCheckout = () => {
    const page = document.querySelector('.js-checkout-page');
    if (!page) return;

    const orderItems = page.querySelector('.js-checkout-items');
    if (orderItems) {
      const subtotal = cart.reduce((s, item) => s + item.price * item.qty, 0);
      orderItems.innerHTML = cart.map(item => `
        <div class="d-flex justify-content-between align-items-center py-2 border-bottom" style="border-color:rgba(1,46,64,0.08)">
          <div><div class="fw-bold small">${item.title}</div><div class="text-muted-ox" style="font-size:0.78rem;">Qty: ${item.qty}</div></div>
          <div class="fw-bold small">${formatMoney(item.price * item.qty)}</div>
        </div>
      `).join('');
      const subEl = page.querySelector('.js-checkout-subtotal');
      const totEl = page.querySelector('.js-checkout-total');
      if (subEl) subEl.textContent = formatMoney(subtotal);
      if (totEl) totEl.textContent = formatMoney(subtotal + 12);
    }

    page.querySelectorAll('.js-selectable-card').forEach(card => {
      card.addEventListener('click', () => {
        const group = card.dataset.group;
        page.querySelectorAll(`.js-selectable-card[data-group="${group}"]`).forEach(c => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
      });
    });

    const placeBtn = page.querySelector('.js-place-order');
    if (placeBtn) {
      placeBtn.addEventListener('click', () => {
        placeBtn.disabled = true;
        placeBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span> Processing...';
        setTimeout(() => {
          cart = []; saveCart(); updateMiniCart();
          window.location.href = 'order-success.html';
        }, 1500);
      });
    }
  };

  // ============================================================
  // ORDERS PAGE
  // ============================================================
  const renderOrdersPage = () => {
    const wrap = document.querySelector('.js-orders-list');
    const empty = document.querySelector('.js-orders-empty');
    if (!wrap) return;

    const demoOrders = [
      { id: 'ORD-7842', date: 'May 18, 2026', status: 'delivered', total: 398.99, items: 2 },
      { id: 'ORD-7831', date: 'May 10, 2026', status: 'shipped', total: 129.00, items: 1 },
      { id: 'ORD-7795', date: 'Apr 28, 2026', status: 'delivered', total: 244.50, items: 3 },
      { id: 'ORD-7712', date: 'Apr 12, 2026', status: 'cancelled', total: 89.99, items: 1 },
      { id: 'ORD-7650', date: 'Mar 30, 2026', status: 'delivered', total: 512.00, items: 4 },
    ];

    if (demoOrders.length === 0) {
      wrap.style.display = 'none';
      empty && (empty.style.display = 'block');
      return;
    }
    wrap.style.display = 'block';
    empty && (empty.style.display = 'none');

    const desktop = wrap.querySelector('.js-orders-desktop');
    const mobile = wrap.querySelector('.js-orders-mobile');

    if (desktop) {
      desktop.innerHTML = demoOrders.map(o => `
        <tr>
          <td><a href="order-details.html?id=${o.id}" class="fw-bold text-ox-accent">${o.id}</a></td>
          <td>${o.date}</td>
          <td><span class="status-badge status-${o.status}">${o.status}</span></td>
          <td class="fw-bold">${formatMoney(o.total)}</td>
          <td>${o.items}</td>
          <td><a href="order-details.html?id=${o.id}" class="btn btn-ox btn-ox-outline btn-sm">View</a></td>
        </tr>
      `).join('');
    }

    if (mobile) {
      mobile.innerHTML = demoOrders.map(o => `
        <div class="order-card-mobile">
          <div class="order-card-header">
            <a href="order-details.html?id=${o.id}" class="order-number text-ox-accent">${o.id}</a>
            <span class="status-badge status-${o.status}">${o.status}</span>
          </div>
          <div class="order-card-row"><span class="label">Date</span><span>${o.date}</span></div>
          <div class="order-card-row"><span class="label">Total</span><span class="fw-bold">${formatMoney(o.total)}</span></div>
          <div class="order-card-row"><span class="label">Items</span><span>${o.items}</span></div>
          <div class="mt-2"><a href="order-details.html?id=${o.id}" class="btn btn-ox btn-ox-outline btn-sm w-100">View Details</a></div>
        </div>
      `).join('');
    }
  };

  // ============================================================
  // ORDER DETAILS PAGE
  // ============================================================
  const initOrderDetails = () => {
    const page = document.querySelector('.js-order-details-page');
    if (!page) return;
  };

  // ============================================================
  // INIT
  // ============================================================
  const init = () => {
    cleanCompare();
    updateMiniCart();
    updateWishlistIcons();
    updateCompareIcons();
    renderShopGrid();
    initProductPage();
    renderCartPage();
    renderWishlistPage();
    renderComparePage();
    initCheckout();
    renderOrdersPage();
    initOrderDetails();
    upgradeStaticCartButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
